import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$accountsCommissionsSummaryFactory} from "../../$accountsCommissionsSummary.factory";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class SupplyAccountsCommissionsSummaryTableCtrl implements IController {
  ids: string[];
  query: any;
  selectedIds: string;
  onSelect: Function;

  public accountsRef: any;
  public loadLimit = 20;
  public infiniteScroll: any;
  public isScrollable: any;
  public selectedKeys: any;


  constructor(private $infiniteScroll, private $accountsCommissionsSummary: $accountsCommissionsSummaryFactory,
              private moment, private $log, private commonsAlertsService: CommonsAlertsService, private $mdMedia) {
  }

  $onInit() {
    this.accountsRef = this.$accountsCommissionsSummary();
    this.accountsRef.$query(this._getQuery());
    this.infiniteScroll = this.$infiniteScroll(this.accountsRef, this.loadLimit, {getFullData: true});
    this.selectedKeys = {};
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }

    if (
      (changes.ids && !changes.ids.isFirstChange()) ||
      (changes.query && !changes.query.isFirstChange())
    ) {
      this._reload();
    }
  };

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-sm');
  };

  _reload() {
    this.accountsRef.$query(this._getQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to load billing accounts ', error);
      })
  }

  _getQuery() {
    return {
      limit: this.loadLimit,
      ids: this.ids,
      query: this.query,
      desc: true
    }
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountsCommissionsSummaryTable', {
    bindings: {
      ids: '<?',
      query: '<?',
      onSelect: '&'
    },
    template: require('./supply-accounts-commissions-summary-table.html').default,
    controller: SupplyAccountsCommissionsSummaryTableCtrl
  });
